import {kInternalRoutes} from "../../constants/internalRoutes";
import {useNavigate} from "react-router-dom";
import {LogoTextSize} from "../../controllers/SystemUmmiaLogoTextController";
import SystemTopBarNavigation from "../others/SystemTopBarNavigation";
import SystemDrawerIcon from "../icons/SystemDrawerIcon";
import HomeSupportProjectButton from "../buttons/homeScreen/HomeSupportProjectButton";
import SystemScreenTopBarUmmiaLogo from "../others/SystemScreenTopBarUmmiaLogo";

export default function SystemScreenTopBar ({currentTab, openDrawer, isForHomeScreen}) {
    // Used in HomeScreen to display screen top bar

    // PROPERTIES
    let navigate = useNavigate()

    // BUILD
    return (
        <div className={"bg-backgroundLight1 w-full h-[72px] min-h-[72px] max-h-[72px] flex justify-center items-center"}>
            <div className={"w-full xl:w-[1200px] flex justify-between items-center px-[16px] lg:px-[24px]"}>
                <div className={"flex justify-start items-center space-x-[8px] md:space-x-[12px]"}>
                    <SystemScreenTopBarUmmiaLogo logoTextSize={LogoTextSize.SMALL}
                                                 onLogoPressed={isForHomeScreen ? null : () => navigate(kInternalRoutes.home)} />
                    <SystemTopBarNavigation currentTab={currentTab} />
                </div>
                <div className={"flex justify-end items-center space-x-[16px] md:space-x-[24px]"}>
                    {isForHomeScreen && (<HomeSupportProjectButton />)}
                    <SystemDrawerIcon onPressed={openDrawer} />
                </div>
            </div>
        </div>
    );
}